import { LeaderboardPlayerData } from 'src/app/core/services/leaderboards/models/leaderboard-player-data';

export enum TournamentStatus {
  NotStarted = 'NOT STARTED',
  Live = 'Live',
  JoinOnly = 'JOIN ONLY',
  CollectingResults = 'COLLECTING RESULTS',
  Finished = 'Finished',
}

export interface TopScore {
  icon: string;
  iconColor: string;
  content: string;
  prize: string;
  score?: number;
}

export interface LeaderboardPrizeRanks {
  leaderboardPlayer: LeaderboardPlayerData;
  prizePillLabel: string;
}

export interface TournamentPrize {
  count: number;
  amount: number;
}
